<template>
  <div>
    <div class="form-group row mb-4" id="notification-table__container">
      <div class="col-lg-12">
        <frontend-paginated-talents-table
          v-if="talents"
          :talents="talents"
          :showTitle="false"
          @talentsTableUpdate="updateChosenTalents($event)"
        />

        <div class="form-group row mt-5">
          <label
            for="departments"
            class="col-form-label col-lg-2 offset-lg-1">
            {{ $t("tasks.talents-table.form.chosen-talents-amount") }}
          </label>
          <div class="col-lg-6">
            <label>{{ chosenTalents.length }}</label>
          </div>
        </div>

        <div class="row justify-content-start" v-if="isTaskNotifyable()">
          <div class="col-lg-2 offset-lg-1">
            <b-button
              variant="success"
              @click="publishTask">
              {{ $tc("tasks.talents-table.form.send-notification-button-text", chosenTalents.length > 1 ? 2 : 1) }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FrontendPaginatedTalentsTable from './frontend-paginated-talents-table';
import { taskService } from '@/helpers/services/tasks/taskService';


export default {
  name: "NotificationTable",
  components: { FrontendPaginatedTalentsTable },
  props: {
    talents: {
      type: Array,
      required: true,
    },
    departmentTitle: {
      type: String,
      required: true,
    },
    task: {
      required: true,
    }
  },
  data() {
    return {
      chosenTalents: [],
    };
  },
  methods: {
    async publishTask() {

      if (!this.isTaskNotifyable) {
        return;
      }

      const isInputCorrect = await taskService.checkTaskData(
        this.departmentTitle,
        this.chosenTalents.length,
        this.task
      );

      console.log(isInputCorrect);
      if (isInputCorrect) {
        const talentIds = this.getIdsFromTalents(this.chosenTalents);
        this.$emit("prepareAndPublishTask", talentIds);
      }
    },
    isTaskNotifyable() {
      if (this.chosenTalents.length < 1) {
        return false;
      }

      return true;
    },
    updateChosenTalents(talents) {
      this.chosenTalents = talents.chosenTalents;
    },
    getIdsFromTalents(talents) {
      return talents.map(talent => talent.id);
    }
  },
};
</script>